import { render } from "./ItemSlide.vue?vue&type=template&id=9361cade&scoped=true"
import script from "./ItemSlide.vue?vue&type=script&lang=js"
export * from "./ItemSlide.vue?vue&type=script&lang=js"

import "./ItemSlide.vue?vue&type=style&index=0&id=9361cade&lang=scss&scoped=true"

import exportComponent from "/home/mmelillo/development/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9361cade"]])

export default __exports__